import { gql } from '@apollo/client';

export const PRICING_PAGE_HEADER_DATA = gql`
  query PricingPageHeaderData($languages: [String], $url_key: String) {
    content {
      pricing_pages(filter: { url_key: { _eq: $url_key } }) {
        title
        title_color
        layout {
          item {
            __typename
            ... on pricing_pages_single_layout {
              ...singleLayoutData
            }
            ... on pricing_pages_multi_layout {
              ...multiLayoutData
            }
          }
        }
      }
    }
  }

  fragment singleLayoutData on pricing_pages_single_layout {
    product {
      title
      sku
      links {
        products_links_id {
          translations(
            filter: { languages_code: { code: { _in: $languages } } }
          ) {
            title
            url
            languages_code {
              code
            }
          }
        }
      }
    }
  }

  fragment multiLayoutData on pricing_pages_multi_layout {
    links {
      translations(filter: { languages_code: { code: { _in: $languages } } }) {
        title
        url
        languages_code {
          code
        }
      }
    }
  }
`;
